<template>
  <section
    class="main-banner"
    data-testid="elem_u_000221"
  >
    <div
      class="title-container"
      data-testid="elem_u_000225"
    >
      <h1 data-testid="elem_u_002575">
        <span data-testid="elem_u_000226">#1 VR Porn&nbsp;</span>
        <br
          class="title-wrap"
          data-testid="elem_u_002574"
        />
        <span
          class="text-primary"
          data-testid="elem_u_000227"
        >
          Affiliate Program
        </span>
      </h1>
      <p data-testid="elem_u_002784">Start earning with our Exclusive VR Porn Offers.</p>
    </div>
    <div
      class="banner-container"
      data-testid="elem_u_002576"
    >
      <picture
        class="main-picture"
        data-testid="elem_u_002577"
      >
        <source
          media="(max-width: 400px)"
          srcset="@/assets/img/home/main-banner/site-images/network-backgtound-mobile.svg"
          data-testid="elem_u_002578"
        />
        <source
          media="(max-width: 1199px)"
          srcset="@/assets/img/home/main-banner/site-images/network-backgtound-tablet.png"
          data-testid="elem_u_002578"
        />
        <img
          class="background"
          src="@/assets/img/home/main-banner/site-images/network-backgtound.png"
          alt="Network Image"
          loading="eager"
          data-testid="elem_u_002579"
        />
      </picture>

      <v-tabs-items
        v-model="model"
        v-if="sites"
        background-color="transparent"
        class="banner-images"
        data-testid="elem_u_000239"
      >
        <v-tab-item
          class="image-tab"
          v-for="(site, index) in sites"
          :key="site.name"
          :value="`tab-${site.name}`"
          data-testid="elem_u_000240"
        >
          <picture
            class="banner-picture"
            data-testid="elem_u_000241"
          >
            <source
              media="(max-width: 1199px)"
              :srcset="site.srcMobile"
              data-testid="elem_u_000242"
            />
            <img
              class="banner-image"
              :src="site.srcDesktop"
              alt="Banner Image"
              data-testid="elem_u_000243"
              :loading="index === 0 ? 'eager' : 'lazy'"
              width="540"
              height="540"
            />
          </picture>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div
      class="actions-container"
      data-testid="elem_u_002785"
    >
      <p
        class="main-banner__subtext"
        data-testid="elem_u_000229"
      >
        Our premium network
      </p>
      <v-tabs
        v-if="sites"
        v-model="model"
        background-color="transparent"
        draggable="false"
        class="banner-tabs"
        scrollable
        hide-slider
        data-testid="elem_u_000230"
      >
        <v-tab
          v-for="site in sites"
          :key="site.name"
          :href="`#tab-${site.name}`"
          class="pa-0 banner-tab"
          draggable="false"
          data-testid="elem_u_000232"
          :ripple="false"
        >
          <div
            class="icon-wrapper"
            data-testid="elem_u_003218"
          >
            <v-img
              draggable="false"
              height="20"
              :alt="`tab-${site.name}`"
              :src="site.icon"
              contain
              data-testid="elem_u_000233"
            />
          </div>
        </v-tab>
      </v-tabs>
      <UnzipButton
        :to="{ name: 'Signup' }"
        width="178"
        widthSm="100%"
        height="50"
        class="btn-join"
        data-testid="elem_u_000234"
      >
        Join Today
      </UnzipButton>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MainBanner',

  props: {
    sites: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      model: 'tab-1',
      currentImage: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.main-banner {
  position: relative;
  display: grid;
  column-gap: 20px;
  row-gap: 60px;
  width: 100%;
  height: fit-content;
  box-sizing: border-box;
  overflow: hidden;
  padding-top: 100px;
  padding-bottom: 100px;

  grid-template-columns: 1fr 1fr;
  grid-template-rows: 241px 240px;
  grid-template-areas: 'title banner' 'actions banner';

  @media (max-width: 1680px) {
    padding-top: 50px;
    padding-bottom: 30px;
    row-gap: 50px;
  }

  @include lg-down {
    row-gap: 20px;
    max-width: 100%;

    grid-template-columns: 100%;
    grid-template-rows: auto 54.6875vw auto;
    grid-template-areas: 'title' 'banner' 'actions';
  }

  @include sm-down {
    row-gap: 20px;
    grid-template-rows: auto 53.333vw auto;
  }

  .main-banner__subtext {
    color: #8d8d8d;
  }

  .title-container {
    grid-area: title;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 35px;
    color: var(--color-grey-900);
    height: fit-content;
    margin-top: 20px;

    @include lg-down {
      gap: 20px;
      margin-top: 0;
      margin-bottom: 30px;
    }

    @include sm-down {
      margin-bottom: 10px;
    }

    h1 {
      font-size: 68px;
      font-style: normal;
      font-weight: 700;
      line-height: 80px;

      @include lg-down {
        font-size: 40px;
        line-height: 47px;
      }
      @include sm-down {
        font-size: 30px;
        line-height: 35px;
      }
    }

    p {
      font-size: 22px;
      line-height: 26px;
      margin: 0;
      @include lg-down {
        font-size: 16px;
        line-height: 19px;
      }
    }

    .title-wrap {
      @include lg-down {
        display: none;
      }
      @include sm-down {
        display: block;
      }
    }
  }
  .text-primary {
    color: var(--color-primary);
  }

  .banner-container {
    grid-area: banner;
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: flex-end;
    align-items: center;

    @include lg-down {
      width: 100vw;
      left: -22px;
    }
    @media (max-width: 500px) {
      left: -15px;
    }
    .background {
      max-height: 100%;
      max-width: 100%;
      height: auto;
      width: auto;
    }
    .main-picture {
      line-height: 0;
      position: absolute;
      left: 0;
      top: 50%;
      transform-origin: center;
      transform: translateY(-50%);
      width: 100%;
      height: auto;

      @include md-down {
        top: 0;
        transform: translateY(0);
      }
    }
  }
  .banner-images {
    height: 100%;
    aspect-ratio: 1;
    max-width: 100%;
    overflow: hidden;
    border-radius: 25px;

    @media (max-width: 1680px) {
      height: fit-content;
      width: 65.85%;
      border-radius: 25px 0 0 25px;
    }

    @include lg-down {
      width: auto;
      height: 100%;
    }

    @include sm-down {
      border-radius: 20px 0 0 20px;
    }
  }
  .image-tab,
  .banner-picture {
    background-color: var(--color-grey-280);
    width: 100%;
    height: 100%;

    .banner-image {
      object-fit: cover;
      aspect-ratio: 1;
      max-height: 100%;
      max-width: 100%;
    }
  }
  .actions-container {
    grid-area: actions;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: fit-content;
    p {
      font-size: 16px;
      line-height: 19px;
      margin-bottom: 20px;
    }
  }
  .banner-tabs {
    width: fit-content;
    height: fit-content;
    max-width: 540px;

    @include lg-down {
      width: 100%;
      min-width: 100%;
    }
  }
  .banner-tab {
    height: 28px;
    width: fit-content;
    margin-right: 5px;
    min-width: fit-content;
    align-items: flex-start;
    &:last-child {
      margin-right: 0;
    }
    @media (max-width: 500px) {
      margin-right: 30px;
    }
  }
  .btn-join {
    margin-top: 60px;

    @include lg-down {
      margin-top: 50px;
    }
    @media (max-width: 500px) {
      width: 100%;
      margin-top: 30px;
    }
  }
}
</style>

<style lang="scss">
// https://github.com/vuetifyjs/vuetify/issues/8875
.banner-tabs {
  .v-slide-group__content {
    max-width: 100%;
    flex-wrap: wrap;
    gap: 15px;

    @include md-down {
      flex-wrap: nowrap;
      max-width: unset;
    }

    .v-tab {
      position: relative;
    }

    .v-tab:hover::before {
      opacity: 0;
    }

    .v-tab:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 2px;
      color: var(--color-primary);
      opacity: 0;
      transition: opacity 0.3s ease-in;
      top: calc(100% - 2px);
      left: 0;
    }

    .v-tab--active:before {
      opacity: 1 !important;
    }
    .v-tab--active:hover:before {
      opacity: 1 !important;
    }
  }
  .v-slide-group__wrapper,
  .v-slide-group__content,
  .v-tabs-bar {
    height: fit-content;
  }

  .v-slide-group__prev {
    display: none !important;
  }
}

.v-slide-group__wrapper {
  height: 32px;
}
</style>
